/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type pin_FullPlanNote$ref: FragmentReference;
declare export opaque type pin_FullPlanNote$fragmentType: pin_FullPlanNote$ref;
export type pin_FullPlanNote = {|
  +id: string,
  +text: string,
  +auditMeta: ?{|
    +created: any,
    +createdBy: {|
      +userName: string,
      +firstName: string,
      +lastName: string,
    |},
    +updated: any,
    +updatedBy: {|
      +userName: string,
      +firstName: string,
      +lastName: string,
    |},
  |},
  +pinned: boolean,
  +$refType: pin_FullPlanNote$ref,
|};
export type pin_FullPlanNote$data = pin_FullPlanNote;
export type pin_FullPlanNote$key = {
  +$data?: pin_FullPlanNote$data,
  +$fragmentRefs: pin_FullPlanNote$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "userName",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "pin_FullPlanNote",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "text",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AuditMeta",
      "kind": "LinkedField",
      "name": "auditMeta",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "created",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AuditUser",
          "kind": "LinkedField",
          "name": "createdBy",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updated",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AuditUser",
          "kind": "LinkedField",
          "name": "updatedBy",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pinned",
      "storageKey": null
    }
  ],
  "type": "PlanNote",
  "abstractKey": null
};
})();
// prettier-ignore
(node/*: any*/).hash = 'dcf3ad7d2fbb051aae5023ba38a5d4e3';

module.exports = node;
